var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container py-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-md-5 col-sm-12"},[_c('NavBarJob',{attrs:{"jobParent":_vm.jobId}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-md-7 col-sm-12 mt-3 pt-4"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b07b207c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/#pages/jobs/Generate.vue
// module id = null
// module chunks = 